<template>
  <div>
    <div class="flex-col ml-119">
      <div class="flex-col items-center self-stretch">
        <span class="font_8 text_15">项目申请模板</span>
        <img
          class="mt-16 image_2"
          src="https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=8d2cf7729a7ddf6398a78b38afb0e730.png"
        />
      </div>
      <span class="mt-58 self-start font_3">相关文件：</span>
    </div>
    <div class="row-box">
      <p v-for="(item, index) in linkData" class="row" :key="index" @click="goLink(item)">
        <span class="name">{{item.name}}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      linkData: [
        // { id: 1, name: '电工行业高质量发展合格评定创新项目立项申请表.word' },
        // { id: 1, name: '电工行业高质量发展合格评定创新项目立项申请表.word' },
        // { id: 1, name: '电工行业高质量发展合格评定创新项目立项申请表.word' }
      ]
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getTmp()
    },
    async getTmp () {
      const res = await this.$https.getXmsqmbList()
      this.linkData = res.data.data
    },
    goLink (item) {
      // todo 去下载
      console.log('goLink==>', item)
      const { attach } = item
      window.open(this.$baseUrl + attach, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.text_15 {
  margin-top: 70px;
  font-family: PingFang;
  font-weight: bold;
  font-size: 20px;
  color: #0067D1;
  line-height: 22px;
}
.image_2 {
  width: 892px;
  height: 2px;
}
.font_3 {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  line-height: 26px;
  margin-left: 79px;
  margin-bottom: 10px;
}
  .row-box{
    display: flex;
    flex-direction: column;
    padding: 0px 79px;

    .row{
      margin: 0px;
      margin-bottom: 10px;
      cursor: pointer;

      &:hover .name{
        opacity: .5;
      }

      .name {
        border-bottom: 1px solid #333;
      }
    }
  }
</style>
